<template>
  <div class="custom-menu-tree">
    <el-button type="text"
               :disabled="list.length === 0"
               @click="appendGroupMenu()">添加分组菜单</el-button>
    <el-tree :data="list"
             draggable
             :allow-drop="allowDrop"
             :expand-on-click-node="false"
             node-key="menuId"
             :props="defaultProps"
             default-expand-all>
      <span class="custom-tree-node"
            slot-scope="{ node, data }">
        <span :style="{ color: data.funcId != null ? '#333' : '#409eff' }">{{ node.label }}{{ data.funcId != null ?  '' : '（分组）'}}</span>
        <div>
          <el-button type="text"
                     v-if="data.funcId == null"
                     @click="() => appendGroupMenu(data)">添加子分组</el-button>
          <el-button type="text"
                     @click="() => editMenu(node, data)">编辑</el-button>
          <el-button type="text"
                     :disabled="data.funcId != null"
                     @click="() => remove(node, data)">删除</el-button>
        </div>
      </span>
    </el-tree>
    <menu-node-modal ref="menu"
                     :callback="callback" />
  </div>
</template>
<script>
// import { guid } from '@/utils/index'
import { guid } from '../../utils'
import MenuNodeModal from './menu-node-modal.vue'
export default {
  name: 'custom-menu-tree',
  components: { MenuNodeModal },
  props: {
    orgId: { type: [Number, null], default: null },
    autoLoad: { type: Boolean, default: true }
  },
  data () {
    return {
      loading: false,
      list: [],
      defaultProps: { children: 'children', label: 'menuName' },
      callback: null
    }
  },
  mounted () {
    if (this.autoLoad) {
      this.fetch(this.orgId)
    }
  },
  methods: {
    appendGroupMenu (data) {
      console.log(data)
      if (data) {
        this.$refs.menu.init({ menuId: 'custom_' + guid() })
        this.callback = function (ruleForm) {
          if (!data.children) {
            this.$set(data, 'children', [])
          }
          data.children.push({ ...ruleForm })
          this.callback = null
        }.bind(this)
      } else {
        this.$refs.menu.init({ menuId: 'custom_' + guid() })
        this.callback = function (ruleForm) {
          this.list.push({ ...ruleForm })
          this.callback = null
        }.bind(this)
      }
    },
    editMenu (node, data) {
      this.$refs.menu.init(data)
      this.callback = function (ruleForm) {
        const parent = node.parent
        const children = parent.data.children || parent.data
        const index = children.findIndex(d => d.menuId === data.menuId)
        children.splice(index, 1, { ...ruleForm })
        this.callback = null
      }.bind(this)
    },
    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.menuId === data.menuId)
      const functions = []
      this.getFuncAddress(data.children || [], functions)
      this.list.push(...functions)
      children.splice(index, 1)
    },
    allowDrop (draggingNode, dropNode, type) {
      if (type === 'inner' && !!dropNode.data.funcId) {
        return false
      }
      return true
    },
    getFuncAddress (list, array) {
      list.forEach(item => {
        const { funcId, menuId, menuName, children } = item
        if (funcId != null) {
          array.push({ funcId, menuId, menuName })
        }
        if (children) {
          this.getFuncAddress(children, array)
        }
      })
    },
    formatMenuTree (list, array) {
      list.forEach(item => {
        const { funcId, menuId, menuName, funcName, children } = item
        const menuItem = { funcId, menuId, menuName, funcName, children: children ? [] : null }
        array.push(menuItem)
        if (children) {
          this.formatMenuTree(children, menuItem.children)
        }
      })
    },
    fetch (orgId) {
      const fetchArray = [
        this.$$CommonApi.getorgportalmenutree({ orgId, customizeMenu: true }),
        this.$$CommonApi.getorgfunctions({ orgId })
      ]
      Promise.all(fetchArray)
        .then(res => {
          const [res1, res2] = res
          if (res1.data.result === 0 && res2.data.result === 0) {
            if (res2.data.functions.length === 0) {
              this.$message.error('请先维护功能')
              return
            }
            const functions = []
            this.getFuncAddress(res1.data.menuNodes || [], functions)
            // console.log('functions', functions, res2.data.functions)
            const funcIds = functions.map(i => i.funcId)
            let functionList = res2.data.functions.filter(i => !funcIds.includes(i.funcId))
            functionList = functionList.map(i => {
              const { funcId, funcName } = i
              return { funcId, menuId: 'custom_' + guid(), menuName: funcName, funcName }
            })
            let menuTree = []
            this.formatMenuTree(res1.data.menuNodes || [], menuTree)
            // console.log(menuTree)
            this.list.push(...menuTree, ...functionList)
          } else {
            this.$message.error(res1.data.result !== 0 ? res1.data.message : res2.data.message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    customInit (functionsList) {
      this.$$CommonApi.getportalprofile({ portalProfileId: this.orgId })
        .then(res => {
          const { result, menuTree, message } = res.data
          if (result === 0) {
            const functions = []
            this.getFuncAddress(menuTree.menuNodes || [], functions)
            const funcIds = functions.map(i => i.funcId)
            let functionList = functionsList.filter(i => !funcIds.includes(i.funcId))
            functionList = functionList.map(i => {
              const { funcId, funcName } = i
              return { funcId, menuId: 'custom_' + guid(), menuName: funcName, funcName }
            })
            let menuTrees = []
            this.formatMenuTree(menuTree.menuNodes || [], menuTrees)
            this.list.push(...menuTrees, ...functionList)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$message.error(err.message)
        })
    },
    formatPostMenuTree (list, array) {
      list.forEach((item, menuSerial) => {
        const { funcId, menuId, menuName, children } = item
        const menuItem = { funcId, menuId: (menuId + '').includes('custom_') ? null : menuId, menuName, children: children ? [] : null, menuSerial }
        array.push(menuItem)
        if (children) {
          this.formatPostMenuTree(children, menuItem.children)
        }
      })
    },
    getMenuTrees () {
      let menuTree = []
      this.formatPostMenuTree(this.list, menuTree)
      // console.log(menuTree)
      return menuTree
    }
  }
}
</script>
<style lang="stylus">
.custom-menu-tree {
  // margin-bottom: 24px;
  .functions {
    max-height: 360px;
    overflow-y: auto;

    .el-alert {
      padding: 4px 8px;
      cursor: pointer;
    }

    .el-alert+.el-alert {
      margin-top: 4px;
    }
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding-right: 8px;
}
</style>
